import React, { useState } from 'react';
import { Page, NotifyModal } from 'components';
import { Form } from './components';
import Header from '../../components/Header/Header';
import ApiGServer from 'services/ApiGServer';

const EquipmentsAdd = () => {
  const [equipments, setEquipments] = useState({
    nameEquipament: '',
    serialnumber: '',
    observation: ''
  });

  const [type, setType] = useState({ color: "", status: "" });
  const [modalShow, setModalShow] = useState(false);

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ "color": "red", "status": msg })
    setModalShow(true)
  }

  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setEquipments(values => ({
      ...values,
      [field]: value
    }));
  };

  const handleSubmit = async () => {
    if (equipments.serialnumber.length !== 10) {
      handleAlertModalError('O número de série deve conter exatamente 10 caracteres!');
      return;
    }

    try {
      await ApiGServer.post('/equipment/new-equipament', equipments);
      handleAlertModalSuccess('Adicionado com sucesso!');
      setEquipments({
        nameEquipament: '',
        serialnumber: '',
        observation: ''
      });
    } catch (e) {
      handleAlertModalError('Falha ao adicionar!');
    }
  };

  return (
    <Page className="p-3" title="Adicionar Equipamentos">
      <Header page={'Adicionar Equipamentos'} />

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Form
        equipments={equipments}
        fieldChange={handleFieldChange}
        onSubmit={handleSubmit}
      />
    </Page>
  );
};

export default EquipmentsAdd;
